import React, { useState } from "react";
import {
  Card,
  Table,
  Form,
  Dropdown,
  Button,
  Row,
  Col
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
  FiCalendar,
  FiEdit,
  FiTrash2,
  FiMail,
  FiPhone,
  FiMessageSquare
} from "react-icons/fi";
import { FaFacebookF, FaSkype } from "react-icons/fa";
import { Link } from "react-router-dom";

// import EditContactModal from "./EditContactModal";
// import DeleteModal from "./DeleteModal";

import EditContactModal from "../../../components/modals/contacts/edit-contacts/EditContactModal";
import DeleteModal from "../../../components/modals/contacts/edit-contacts/DeleteModal";
import ContactHeader from "../../../components/crm/contact/ContactHeader";
import AddContactModal from "../../../components/modals/contacts/add-contacts/AddContactModal";
const ContactList = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [status, setStatus] = useState("Select Status");
  const [sort, setSort] = useState("Sort By : Last 7 Days");
  const [search, setSearch] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [contactShow, setContactShow] = useState(false);
const data = [
  {
    name: "Darlee Robertson",
    role: "Facility Manager",
    location: "Germany",
    rating: 4.2,
    owner: "Hendry Milner",
    phone: "(163) 2459 315",
    image: "/assets/img/users/user-49.jpg"
  },
  {
    name: "Sharon Roy",
    role: "Installer",
    location: "USA",
    rating: 5.0,
    owner: "Guilory Berggren",
    phone: "(146) 1249 296",
    image: "/assets/img/users/user-50.jpg"
  },
  {
    name: "Vaughan Lewis",
    role: "Senior Manager",
    location: "Canada",
    rating: 3.5,
    owner: "Jami Carlile",
    phone: "(135) 3489 516",
    image: "/assets/img/users/user-51.jpg"
  },
  {
    name: "Jessica Louise",
    role: "Test Engineer",
    location: "India",
    rating: 4.5,
    owner: "Theresa Nelson",
    phone: "(158) 3459 596",
    image: "/assets/img/users/user-02.jpg"
  },
  {
    name: "Carol Thomas",
    role: "UI/UX Designer",
    location: "China",
    rating: 4.7,
    owner: "Smith Cooper",
    phone: "(196) 4862 196",
    image: "/assets/img/users/user-52.jpg"
  },
  {
    name: "Dawn Mercha",
    role: "Technician",
    location: "Japan",
    rating: 5.0,
    owner: "Martin Lewis",
    phone: "(163) 6498 256",
    image: "/assets/img/users/user-57.jpg"
  },
  {
    name: "Rachel Hampton",
    role: "Software Developer",
    location: "Indonesia",
    rating: 3.1,
    owner: "Newell Egan",
    phone: "(154) 6481 075",
    image: "/assets/img/users/user-54-1.jpg"
  }
];

  return (
    <>
<div     style={{ padding: "15px", background: "#f8f9fa" }} >
      <ContactHeader
        title="Contact List"
        openModal={() => setContactShow(true)}
      />
        <Card className="contact-card">
        <Card.Header className="d-flex justify-content-between flex-wrap">
          <h5>Contact List</h5>

          <div className="d-flex flex-wrap gap-2 align-items-center">

            {/* Date Picker */}
            <div className="date-box">
              
              <DatePicker
                selectsRange
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                onChange={(update) => setDateRange(update)}
                placeholderText="dd/mm/yyyy - dd/mm/yyyy"
                className="form-control"
              />
              
            </div>

            {/* Status Dropdown */}
            <Dropdown>
              <Dropdown.Toggle className=" bg-white text-dark">
                {status}
                
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {["Active", "Inactive"].map((item) => (
                  <Dropdown.Item
                    key={item}
                    onClick={() => setStatus(item)}
                    className="dropdown-item-custom"
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Sort Dropdown */}
            <Dropdown>
              <Dropdown.Toggle className=" bg-white text-dark">
                {sort}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {[
                  "Recently Added",
                  "Ascending",
                  "Descending",
                  "Last Month",
                  "Last 7 Days"
                ].map((item) => (
                  <Dropdown.Item
                    key={item}
                    onClick={() => setSort(item)}
                    className="dropdown-item-custom"
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Header>

        <Card.Body>

          {/* Top Controls */}
          <Row className="mb-3">
            <Col md={6}>
              <div className="d-flex align-items-center gap-2">
                <span>Row Per Page</span>
                <Form.Select style={{ width: 80 }}>
                  <option>10</option>
                  <option>25</option>
                </Form.Select>
                <span>Entries</span>
              </div>
            </Col>

            <Col md={6} className="text-end">
              <Form.Control
                placeholder="Search"
                style={{ maxWidth: 250, marginLeft: "auto" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Col>
          </Row>

          {/* Table */}
          <Table responsive className="contact-table">
            <thead style={{  background: "#ffff" }} >
              <tr style={{  background: "#ffff" }}  >
                <th><Form.Check /></th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Location</th>
                <th>Rating</th>
                <th>Owner</th>
                <th>Contact</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, i) => (
                <tr key={i}>
                  <td><Form.Check /></td>

                  {/* Name */}
                  <td className="d-flex align-items-center gap-2">
                    <img src={item.image} className="avatar" />
                    <div>
                      <div className="fw-semibold">{item.name}</div>
                      <small>{item.role}</small>
                    </div>
                  </td>

                  <td>[email protected]</td>
                  <td>{item.phone}</td>
                  <td>{item.location}</td>

                  <td>⭐ {item.rating}</td>
                  <td>{item.owner}</td>

                  {/* Contact Icons */}
                  <td>
                    <div className="contact-icons">
                      <Link to="/mail"><FiMail /></Link>
                      <Link to="/call"><FiPhone /></Link>
                      <Link to="/chat"><FiMessageSquare /></Link>
                      <Link to="/skype"><FaSkype /></Link>
                      <Link to="/facebook"><FaFacebookF /></Link>
                    </div>
                  </td>

                  <td>
                    <span className="badge bg-success">Active</span>
                  </td>

                  {/* Actions */}
                  <td>
                    <FiEdit
                      className="action-icon"
                      onClick={() => setShowEdit(true)}
                    />
                    <FiTrash2
                      className="action-icon"
                      onClick={() => setShowDelete(true)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>

        <style>
          {
            `
            .contact-card {
  border-radius: 6px;
  background: #ffff;

}

.btn-white {
  background: #fff;
  border: 1px solid #ddd;
}

.dropdown-item-custom:hover {
  background: orange;
  color: #fff;
}

.date-box {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-table th {
  background: #f8f9fa;
    border-radius: 6px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.contact-icons a {
  margin-right: 8px;
  color: #6c757d;
}

.contact-icons a:hover {
  color: orange;
}

.action-icon {
  margin-right: 10px;
  cursor: pointer;
}`
          }
        </style>
      </Card>

      {/* Modals */}
      <EditContactModal show={showEdit} onHide={() => setShowEdit(false)} />
           <AddContactModal
        show={contactShow}
        handleClose={() => setContactShow(false)}
      />
      <DeleteModal show={showDelete} onHide={() => setShowDelete(false)} />
</div>
    </>
  );
};

export default ContactList;